export default __webpack_public_path__ + "static/media/logo.9dea1643.png";